import type { ChipOption } from 'client/js/main/screens/ScreenRoiHub/types';

export enum ImportChip {
  COST_DATA_TEMPLATES = 'cost-data-templates',
  IMPORT_HISTORY = 'import-history',
  EMAIL_IMPORTERS = 'email-importers',
  FILE_UPLOAD = 'file-upload',
}

export const CHIPS_SELECTION_OPTIONS: ChipOption[] = [
  { id: ImportChip.IMPORT_HISTORY, label: 'Import History' },
  { id: ImportChip.COST_DATA_TEMPLATES, label: 'Cost data templates' },
  { id: ImportChip.EMAIL_IMPORTERS, label: 'Email Importers' },
  { id: ImportChip.FILE_UPLOAD, label: 'File Upload' },
];
